<div class="flex items-center">
  <p-inputSwitch
    class="green-toggle light-grey-toggle"
    (onChange)="toggleChange.emit($event)"
    [formControl]="formInputCtrl"
    [inputId]="inputId"
  ></p-inputSwitch>
  <span *ngIf="label" class="ml-2 text-[12px] {{ labelStyleClasses }}">{{ label }}</span>
  <ng-content></ng-content>
</div>
